// TelcoTrack — P0.5: signed-status review (message hint ≠ signature_complete).

/** Review proposal created when inbound message text suggests a signed contract. */
export const BREMENA_POSSIBLE_SIGNED_DOCUMENT = 'POSSIBLE_SIGNED_DOCUMENT' as const;

/** Authority event type for the review proposal (not a status transition). */
export const BREMENA_EVENT_POSSIBLE_SIGNED_DOCUMENT = 'bremena_possible_signed_document' as const;

/** Authority event when worker marks signed via audited waiver (no evidence document). */
export const BREMENA_EVENT_SIGNED_STATUS_WAIVER = 'bremena_signed_status_waiver' as const;

export type BremenaPossibleSignedProposal = typeof BREMENA_POSSIBLE_SIGNED_DOCUMENT;

/** Minimum length for an audited waiver reason when marking podepsana without a document. */
export const BREMENA_SIGNED_WAIVER_REASON_MIN_LENGTH = 8;

export function isBremenaSignedWaiverReason(value: string | null | undefined): boolean {
  return (value ?? '').trim().length >= BREMENA_SIGNED_WAIVER_REASON_MIN_LENGTH;
}
